// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"PlWUVqarxucb6pALMqtC","column":"hK00lUcV7yFsX_4ubcPF","pulse":"s3adKmQ_wsGYmwo6SiCe"};